import React, { useRef, useEffect, useState } from "react";
import { Form, Input, Collapse, Empty } from 'antd';
import { NavLink as Link } from 'react-router-dom';
import { animateScroll as scroll } from 'react-scroll';
import {
    SearchOutlined
} from '@ant-design/icons';

const { Panel } = Collapse;

export const Help = () => {
    
    const isInitialMount = useRef(true);
    const [search_list, setSearch_list] = useState("");
    const [form_search_list] = Form.useForm();
    
    form_search_list.setFieldsValue({ 
        search: search_list
    });

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;

            component_start();
        }
    }, []);

    async function component_start() {
        
    }

    const help_list = [
        {
            title: 'Регистрация в системе',
            text: <>
                <p>Для работы с порталом и доступа к полному списку услуг пользователь должен зарегистрироваться и подтвердить регистрацию по ссылке в письме, которое придет на электронный ящик, указанный в анкетных данных.</p>
            </>
        },
        {
            title: 'Как создать учетную запись пользователя портала',
            text: <>
                <ol>
                    <li>Откройте окно авторизации щелкнув левой кнопкой мыши по пункту <strong>«Войти»</strong> в верхнем правом углу страницы.</li>
                    <li>Нажмите на кнопку <strong>«Создать новый аккаунт»</strong>. Отобразится форма <strong>«Регистрация»</strong>.</li>
                    <li>Укажите Ваше имя, фамилию, номер телефона и адрес электронной почты.</li>
                    <li>Нажмите кнопку <strong>«Создать»</strong>.</li>
                </ol>
            </>
        },
        {
            title: 'У меня уже есть учетная запись, как войти?',
            text: <>
                <ol>
                    <li>Откройте окно авторизации щелкнув левой кнопкой мыши по пункту <strong>«Войти»</strong> в верхнем правом углу страницы.</li>
                    <li>Выполните вход под нужным пользователем, указав его электронный адрес и пароль.</li>
                </ol>
            </>
        },
        {
            title: 'Восстановление пароля',
            text: <>
                <ol>
                    <li>Откройте окно авторизации щелкнув левой кнопкой мыши по пункту <strong>«Войти»</strong> в верхнем правом углу страницы.</li>
                    <li>Нажмите на кнопку <strong>«Забыли пароль?»</strong>. Отобразится форма <strong>«Восстановление доступа»</strong>.</li>
                    <li>Восстановление пароля доступно по электронной почте.</li>
                </ol>
                <p>Восстановление пароля по электронной почте</p>
                <ol>
                    <li>Укажите адрес электронной почты, который вы использовали при регистрации вашей учетной записи.</li>
                    <li>Нажмите кнопку <strong>«Продолжить»</strong>. На указанный электронный адрес будет отправлено письмо с кодом и откроется окно ввода кода.</li>
                    <li>Введите 6-ти значный код из письма.</li>
                    <li>Если код был указан верный код, откроется окно ввода нового пароля.</li>
                    <li>В поле <strong>«Новый пароль»</strong> введите и новый пароль.</li>
                    <li>Нажмите кнопку <strong>«Сохранить»</strong>.</li>
                </ol>
            </>
        },
        {
            title: 'Смена пароля',
            text: <>
                <ol>
                    <li>Откройте страницу <Link to='/profile' exact={ true } onClick={() => scroll.scrollToTop()}>профиля пользователя</Link> щелкнув левой кнопкой мыши по пункту <strong>«Профиль»</strong> в верхнем правом углу страницы.</li>
                    <li>Выполните вход под нужным пользователем, указав его электронный адрес и пароль.</li>
                    <li>Перейдите в раздел <strong>«Безопасность»</strong>.</li>
                    <li>В полях <strong>«Старый пароль»</strong>, <strong>«Новый пароль»</strong> введите старый и новый пароль.</li>
                    <li>Нажмите кнопку <strong>«Сохранить»</strong>.</li>
                </ol>
            </>
        },
        {
            title: 'Смена пользователя портала',
            text: <>
                <ol>
                    <li>Нажмите кнопку <strong>«Выход»</strong> в верхнем правом углу страницы.</li>
                    <li>Выполните вход под нужным пользователем, указав его электронный адрес и пароль.</li>
                </ol>
            </>
        },
        {
            title: 'Удаление учётной записи',
            text: <>
                <ol>
                    <li>Свяжитесь с нами по почте <a href="mailto:tk.r2.ru@gmail.com">tk.r2.ru@gmail.com</a></li>
                </ol>
            </>
        }
    ];

    var obj = {
        get help_list () {
            if ( help_list.length > 0 ) {
                let search = search_list.toLowerCase();
                return help_list.filter( function( item ) {
                    return(
                        item['title'].toLowerCase().indexOf( search ) > -1 ||
                        item['text'].toString().toLowerCase().indexOf( search ) > -1
                    );
                } );
            } else {
                return help_list;
            }
        },
    };

    function list_search_change (e) { 
        setSearch_list(e.target.value.replace(/\s+/g,' '));
    }

    const panelStyle = {
        marginBottom: 24,
        background: 'rgba(0, 0, 0, 0.02)',
        borderRadius: 8,
        border: 'none',
    };

    return (
        <>
            <section className='container --help shadow default_padding marginTop'>
                <div className='content'>
                    <h1>Помощь</h1>
                    <Form name="form" className="default_form" form={form_search_list}>
                        <Form.Item key="search" name="search">
                            <Input className={`custom_input`} placeholder="Поиск" onChange={ list_search_change } bordered={false} 
                                prefix={
                                    <SearchOutlined style={{ color: 'rgba(0,0,0,.45)', fontSize: 20 }} />
                                }
                            />
                        </Form.Item>
                    </Form>
                    {obj.help_list.length > 0 ? 
                        <Collapse accordion bordered={false} style={{background: 'transparent'}}>
                            {obj.help_list.map((item, index) => 
                                    <Panel header={item.title} key={index} style={panelStyle}>
                                        {item.text}
                                    </Panel>
                            )}
                        </Collapse>
                    :
                        <Empty description="Ничего не найдено" />
                    }
                </div>
            </section>
        </>
    );
};